import images from '@assets/images/index'

import { Button } from '@suntex.fim/ui'

interface MyQuestCarouselArrowProps {
  className?: string
  style?: React.CSSProperties
  onClick?: () => void
}

export const MyQuestCarouselNextArrow = ({
  className,
  style,
  onClick
}: MyQuestCarouselArrowProps) => {
  return (
    <div className="carousel-btn">
      <Button
        intent="icon"
        className={`${className || ''} custom-next-arrow`}
        style={{
          ...style,
          display: 'block',
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }}
        onClick={onClick}
        aria-label="Next slide"
        icon={<images.ArrowGrey />}
      />
    </div>
  )
}

export const MyQuestCarouselPrevArrow = ({
  className,
  style,
  onClick
}: MyQuestCarouselArrowProps) => {
  return (
    <div className="carousel-btn">
      <Button
        intent="text"
        className={`${className || ''} custom-prev-arrow`}
        style={{
          ...style,
          display: 'block',
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }}
        onClick={onClick}
        aria-label="Previous slide"
      >
        <images.ArrowGrey />
      </Button>
    </div>
  )
}
